import app from 'flarum/forum/app';
import CustomFooter from './components/CustomFooter';
import CustomHeader from './components/CustomHeader';
import CustomImage from './components/CustomImage';
import addIntroToAboutPage from './extend/addIntroToAboutPage';
import adjustBlogItems from './extend/adjustBlogItems';
import changeAuthorsListPath from './extend/changeAuthorsListPath';
import hideBlogForumNav from './extend/hideBlogSidebar';
import hideReplyButtonForGuests from './extend/hideReplyButtonForGuests';
import removeAuthHeaderLinks from './extend/removeAuthHeaderLinks';

app.initializers.add(
  'bhasvic/flarum-theme',
  () => {
    hideBlogForumNav();
    removeAuthHeaderLinks();
    changeAuthorsListPath();
    addIntroToAboutPage();
    adjustBlogItems();
    hideReplyButtonForGuests();

    CustomHeader.mount();
    CustomFooter.mount();
    CustomImage.mount();

    // setTimeout(afterAppInitializedActions, 0);
  },
  -9e10 // Priority: run this initializer last
);

/**
 * Because `app.forum` is `null` when our initialiser is run, we cannot
 * access Flarum's forum attributes immediately. Instead, we need to
 * call another function immediately after initialisation is complete,
 * which will perform any logic we need.
 */
function afterAppInitializedActions() {
  // empty for now
}
